import postApi from '@/api/postApi'
export default {
  namespaced: true,

  state: {
    loading: null,
    news: null,
    categories: [],
    pagination: {

    }
  },
  getters: {
    news: state => state.news,
    categories: state => state.categories,
    loading: state => state.loading,
    pagination: state => state.pagination
  },
  mutations: {
    SET_NEWS (state, value) {
      state.news = value
    },
    SET_PAGINATION (state, value) {
      if (value != null) {
        if (value.total !== undefined) {
          state.pagination.total = value.total
        }
        if (value.current_page !== undefined) {
          state.pagination.currentPage = value.current_page
        }
        if (value.from !== undefined) {
          state.pagination.pageItemFrom = value.from
        }
        if (value.to !== undefined) {
          state.pagination.pageItemTo = value.to
        }

        if (value.last_page !== undefined) {
          state.pagination.pageCount = value.last_page
        }
      }
    },
    SET_LOADING (state, value) {
      state.loading = value
    },
    SET_CATEGORY (state, value) {
      state.categories = value
    }
  },
  actions: {

    async index ({ commit }, params) {
      commit('SET_LOADING', true)
      try {
        const response = await postApi.getNews(params)
        commit('SET_NEWS', response.data)
        commit('SET_PAGINATION', response.data)
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async fetchCategories ({ commit }) {
      commit('SET_LOADING', true)
      try {
        const response = await postApi.getCategories()
        commit('SET_CATEGORY', response.data)
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async insertNews ({ commit }, params) {
      commit('SET_LOADING', true)
      try {
        await postApi.insertNews(params)
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async updateNews ({ commit }, params) {
      commit('SET_LOADING', true)
      try {
        const p = { id: params.id, title: params.title, body: params.body, is_for_subscriber: params.is_for_subscriber, category_id: params.category.id, images: params.new_images }
        await postApi.updateNews(p)
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async getNewsById ({ commit }, id) {
      commit('SET_LOADING', true)
      try {
        const response = await postApi.getNewsById(id)
        commit('SET_NEWS', response.data)
      } finally {
        commit('SET_LOADING', false)
      }
    }
  }
}
